import React from 'react';
import PropTypes from 'prop-types';

const PVListingToolbar = (props) => {
    const { titleProduct, sortOptions, pagingOptions, layoutOptions } = props;
    return (
        <div className="toolbar-products">
            <h4 className="title-product">{titleProduct}</h4>
            <div className="toolbar-option">
                {sortOptions && sortOptions.use ? (
                    <div className="toolbar-sort">
                        <select
                            className="chosen-select sorter-options form-control"
                            onChange={(e) => sortOptions.changeFunc(e.target.value)}
                        >
                            {sortOptions && sortOptions.use
                                ? sortOptions.opts.map((option) => {
                                      return (
                                          <option key={option.id} value={option.value}>
                                              {option.display}
                                          </option>
                                      );
                                  })
                                : ''}
                        </select>
                    </div>
                ) : (
                    ''
                )}
                {pagingOptions && pagingOptions.use ? (
                    <div className="toolbar-per form-inline">
                        <label htmlFor={pagingOptions.fieldName}>
                            Show &nbsp;
                            <select
                                name={pagingOptions.fieldName}
                                className="chosen-per sorter-options form-control"
                                defaultValue={
                                    pagingOptions.selectedVal &&
                                    pagingOptions.opts.find(
                                        (x) => x.value === pagingOptions.selectedVal
                                    )
                                        ? pagingOptions.opts.find(
                                              (x) => x.value === pagingOptions.selectedVal
                                          ).value
                                        : pagingOptions.opts[0]
                                }
                                onChange={(e) => pagingOptions.changeFunc(e.target.value)}
                            >
                                {pagingOptions.opts.map((option) => {
                                    return (
                                        <option key={option.id} value={option.value}>
                                            {option.display}
                                        </option>
                                    );
                                })}
                            </select>
                            &nbsp;per&nbsp;page
                        </label>
                    </div>
                ) : (
                    ''
                )}
                {layoutOptions && layoutOptions.use ? (
                    <div className="layouts">
                        <button
                            type="button"
                            className={`layouts-layout layout-grid ${
                                layoutOptions.selectedVal === 'grid' ? 'active' : ''
                            }`}
                            title="Grid"
                            onClick={() => layoutOptions.changeFunc('grid')}
                        >
                            <i className="flaticon-squares" />
                            <span>Grid</span>
                        </button>
                        <button
                            type="button"
                            title="List"
                            className={`layouts-layout layout-list ${
                                layoutOptions.selectedVal === 'list' ? 'active' : ''
                            }`}
                            onClick={() => layoutOptions.changeFunc('list')}
                        >
                            <i className="flaticon-interface" />
                            <span>List</span>
                        </button>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

PVListingToolbar.propTypes = {
    titleProduct: PropTypes.string,
    sortOptions: PropTypes.shape({
        opts: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                display: PropTypes.string,
                value: PropTypes.string,
            })
        ),
        selectedVal: PropTypes.string,
        changeFunc: PropTypes.func,
        use: PropTypes.bool,
        label: PropTypes.string,
    }),
    pagingOptions: PropTypes.shape({
        opts: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                diplay: PropTypes.string,
                value: PropTypes.number,
            })
        ),
        selectedVal: PropTypes.number,
        changeFunc: PropTypes.func,
        use: PropTypes.bool,
        label: PropTypes.string,
        fieldName: PropTypes.string,
    }),
    layoutOptions: PropTypes.shape({
        selectedVal: PropTypes.oneOf(['grid', 'list']),
        changeFunc: PropTypes.func,
        use: PropTypes.bool,
    }),
};
PVListingToolbar.defaultProps = {
    titleProduct: '',
    sortOptions: {},
    pagingOptions: {
        opts: [
            { id: 0, value: 5, display: '5' },
            { id: 1, value: 10, display: '10' },
            { id: 2, value: 20, display: '20' },
            { id: 3, value: 50, display: '50' },
            { id: 4, value: 100, display: '100' },
            { id: 5, value: 0, display: 'All' },
        ],
        selectedVal: 10,
        changeFunc: () => {},
        use: true,
        fieldName: 'productPaging',
    },
    layoutOptions: {},
};

export default PVListingToolbar;
